import { useTranslation } from 'react-i18next'

import Table from '~/components/Table'
import { Badge } from '~/components/UI/Badge'

import { placementNamesBestPractices } from './content'
import { placementNamesBestPracticesSchema } from './schema'

const BestPracticesModal: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <section>
        <header>{t('rm:placements.bestPractices.modal.description')}</header>

        <p>
          <strong>{t('rm:placements.bestPractices.modal.goodModel')}</strong>
        </p>

        <Badge
          template="info"
          text={`{${t('rm:placements.bestPractices.table.device')}}_{${t('rm:placements.bestPractices.table.context')}}_{${t('rm:placements.bestPractices.table.position')}}_{${t('rm:placements.bestPractices.table.adType')}}`}
        />
      </section>

      <Table
        schema={placementNamesBestPracticesSchema}
        data={placementNamesBestPractices}
        className="mx-auto mt-3"
        sideBorder
        smallerRowPadding
      />
    </>
  )
}

export default BestPracticesModal
